import { createAsyncThunk } from '@reduxjs/toolkit';

import { authGet } from '../../utils/request';

const getUploadsList = createAsyncThunk(
  'users/getUploadsList',
  async ({ page = 1, refresh } = {}, { rejectWithValue }) => {
    try {
      const { data } = await authGet('/users/uploads', {
        params: {
          page: refresh ? 1 : page
        }
      });
      return { ...data, refresh };
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export default getUploadsList;
